import { render } from "./CompanyPlansBenefitsModal.vue?vue&type=template&id=5b898742&scoped=true"
import script from "./CompanyPlansBenefitsModal.vue?vue&type=script&lang=js"
export * from "./CompanyPlansBenefitsModal.vue?vue&type=script&lang=js"

import "./CompanyPlansBenefitsModal.vue?vue&type=style&index=0&id=5b898742&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b898742"]])

export default __exports__